export default "__VITE_ASSET__CcF0mt7C__"